import { useReducer } from 'react'

export const SET_VOUCHER_INFO = 'SET_VOUCHER_INFO'
export const SET_IS_ERROR = 'SET_IS_ERROR'
export const SET_APPROVE_SUCCESS = 'SET_APPROVE_SUCCESS'
export const SET_REJECTED_SUCCESS = 'SET_REJECTED_SUCCESS'
export const SET_REJECTED_ERROR = 'SET_REJECTED_ERROR'
export const OPEN_CONFIRM_DIALOG = 'OPEN_CONFIRM_DIALOG'
export const CLOSE_CONFIRM_DIALOG = 'CLOSE_CONFIRM_DIALOG'
export const SET_IS_NOTIFICATION_NOT_FOUND = 'SET_IS_NOTIFICATION_NOT_FOUND'

const initialState = {
  user: {},
  voucher: {},
  openRejectConfirmDialog: false,
  isApproved: false,
  isRejected: false,
  isError: false,
  isNotificationNotFound: false,
}

function reducer(state = '', action) {
  switch (action.type) {
    case SET_VOUCHER_INFO:
      return {
        ...state,
        user: action.user,
        voucher: action.voucher,
        isNotificationNotFound: false,
      }
    case SET_IS_ERROR:
      return {
        ...state,
        isError: true,
      }
    case SET_APPROVE_SUCCESS:
      return {
        ...state,
        isApproved: true,
      }
    case SET_REJECTED_SUCCESS:
      return {
        ...state,
        openRejectConfirmDialog: false,
        isRejected: true,
      }
    case SET_REJECTED_ERROR:
      return {
        ...state,
        openRejectConfirmDialog: false,
        isError: true,
      }
    case OPEN_CONFIRM_DIALOG:
      return {
        ...state,
        openRejectConfirmDialog: true,
      }
    case CLOSE_CONFIRM_DIALOG:
      return {
        ...state,
        openRejectConfirmDialog: false,
      }
    case SET_IS_NOTIFICATION_NOT_FOUND:
      return {
        ...state,
        isNotificationNotFound: true,
      }

    default:
      return state
  }
}

export default () => {
  const [state, dispatchRedemption] = useReducer(reducer, initialState)

  return [state, dispatchRedemption]
}
